export class ClientOrder {
    id: string;
    quantity: number = 1;
    options: {
        option_id: string;
        quantity: number;
    }[];
}
